import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  'en': {
    // INSERT:LandingPage //
    landing:{
      // INSERT:Title
      title: 'Canon Vision',

      // Landing Page register
      register: 'Not Registered? <a href="/register" style="color: #fff !important;">Sign up</a>',

      // INSERT:Opening Paragraph
      openingPara: 'Explore Canon’s full range of Pro AV products and solutions and gain insight into the technology from our team of product specialists and industry-leading professionals, in our virtually reproduced trade show environment.',

      // INSERT:CTA Button
      ctaButton: 'Register now',

      // INSERT:Paragraph Heading
      paraHeading: 'Canon Vision: experience our virtual Pro AV Event',

      // INSERT:Paragraph Body
      paraBody: '<p><ul style="padding-left: 20px;"><li>Introduction to our latest Canon products</li><li>Six live Q&As with imaging professionals</li><li>Short film screenings</li><li>An in-depth look into our full professional video camera, display and lens ranges</li><li>Ideal for broadcasters, cinematographers, independent filmmakers, videographers and more.</li><li>If you’re experiencing any problems with the 3D experience, <a href="https://www.canon-europe.com/pro/events/canon-vision/web-version/?cache=no">click here</a> to view the products on the Canon website</li></p>',
    },
    footer:{
      // INSERT:Privacy Policy
      privacyPolicyFooter: '<a target="_blank" rel="noopener noreferrer" href="https://myid.canon/canonid/#/policy?ui_language=en-EN" style="color: #000 !important;">Privacy Policy</a>',
    },

    // INSERT:Register //

    // INSERT:Login

    registerLogin: 'Already registered? <a href="/" style="color: #fff !important;">Sign in</a>',

    // INSERT:Opening Paragraph
    openingPara: 'Complete the form below and join us for a showcase of our latest products, technology and solutions from our product experts and professionals in the broadcast, film, documentary and production industry.',

    // INSERT:Form Labels
    firstName: 'First name',
    lastName: 'Last name',
    emailAddress: 'Email address',
    companyName: 'Company name',
    country: 'Country',
    contactNumber: 'Contact number',
    jobTitle: 'Job title',
    companyType: 'Company type',
    mainProductionGenre: 'Main Production Genre',
    statementSelect: 'Select the statement which applies to you',

    // INSERT:County Dropdowns
    countyDDSelect: 'Please select a country',

    // INSERT:Company Type Dropdowns
    companyTypeDDSelect: 'Please select your company type',
    companyTypeDD1: 'Network TV (Public)',
    companyTypeDD2: 'Local TV (Public)',
    companyTypeDD3: 'Network TV (Private)',
    companyTypeDD4: 'Local TV (Private)',
    companyTypeDD5: 'OB Truck Companies',
    companyTypeDD6: 'Production Companies',
    companyTypeDD7: 'Post Production Companies',
    companyTypeDD8: 'Equipment Rental Companies',
    companyTypeDD9: 'Independent User / Freelance',
    companyTypeDD10: 'Corporate',
    companyTypeDD11: 'House of Worship / Churches',
    companyTypeDD12: 'Reseller / Distributor',
    companyTypeDD13: 'System Integrator',
    companyTypeDD14: 'Government / Public',
    companyTypeDD15: 'Security Forces / Police',
    companyTypeDD16: 'University / College',
    companyTypeDD17: 'Secondary School',
    companyTypeDD18: 'Primary School',
    companyTypeDD19: 'Other Educational Institutes',
    companyTypeDD20: 'Students',
    companyTypeDD21: 'Other',

    // INSERT:Main Production Genre Dropdowns
    GenreDDSelect: 'Please select your main production genre',
    GenreDD1: 'Film & TV: Documentary',
    GenreDD2: 'Film & TV: Studio/Production',
    GenreDD3: 'Film & TV: Narrative',
    GenreDD4: 'Film & TV: Episodic',
    GenreDD5: 'Film & TV: Sports',
    GenreDD6: 'Film & TV: News/Journalism',
    GenreDD7: 'Commercial/Advertising',
    GenreDD8: 'Corporate Content',
    GenreDD9: 'Educational Content',
    GenreDD10: 'Wedding',
    GenreDD11: 'Music',
    GenreDD12: 'Gaming / Esports',
    GenreDD13: 'House of Worship',
    GenreDD14: 'Internet Content',
    GenreDD15: 'Surveillance',
    GenreDD16: 'Monitoring',
    GenreDD17: 'Others',

    // INSERT:Select the statement which applies to you
    select1: 'Photography or videography is a hobby I spend a lot of time doing',
    select2: 'I am studying for a qualification with a photography or videography focus, such as a degree or diploma',
    select3: 'I sometimes take photos or videos for money or reward – but it is not my main source of income',
    select4: 'I am a full-time photo or video professional – I take photos or videos professionally on a regular basis for a living',
    select5: 'I work in the cinema / broadcasting industry as a professional film-maker, camera operator or similar',
    select6: 'None of the above',

    // INSERT:Email Marketting
    emailMarketting: "Please tick the box if you would like to receive Canon's regular communications about Canon products, events and services via email.",
    emailUnsubscribe: "You will be able to unsubscribe at anytime",

    // INSERT:Mandatory Field
    mandatoryField: 'mandatory field',

    // INSERT:Privacy Policy
    privacyPolicy: 'By clicking SUBMIT you confirm you have read and understood <a target="_blank" rel="noopener noreferrer"href="https://myid.canon/canonid/#/policy">Canon’s Consumer Privacy Policy</a>.',

    // INSERT:Submit
    submitButton: 'Submit',

    // INSERT:Footer
    footerLeft: '<b>Canon Vision</b> Virtual Pro AV Event &#169; Copyright 2020 All Rights Reserved.',
    footerRight: '<a target="_blank" rel="noopener noreferrer"href="http://reydar.com/virtual-events" style="color: #000 !important">This Virtual Event is powered by <img style="height: 12px;vertical-align: baseline;width: auto;object-fit: contain;" src="https://res.cloudinary.com/enginecreative/image/upload/v1599495272/Reydar/Canon/Reydar_Logo_kzslwx.png" alt=""></a>',

    // INSERT:Thank You
    thankyouTitle: 'Thank you for registering.',
    thankyouText: 'Thank you for registering to Canon Vision 2020.<br>You will receive a confirmation email, we look forward to seeing you there.'
  },
  'fr': {
    // INSERT:LandingPage //
    landing:{
      // INSERT:Title
      title: 'Canon Vision',

      // Landing Page register
      register: "Non enregistré? <a href='/register' style='color: #fff !important;'>S'inscrire</a>",

      // INSERT:Opening Paragraph
      openingPara: "Découvrez la gamme complète de solutions et de produits audiovisuels professionnels Canon et obtenez des informations sur notre technologie grâce aux explications de notre équipe composée de spécialistes produits et d'experts du secteur dans notre salon virtuel.",

      // INSERT:CTA Button
      ctaButton: 'ctaButton',

      // INSERT:Paragraph Heading
      paraHeading: 'Canon Vision : découvrez notre événement virtuel dédié au secteur audiovisuel professionnel',

      // INSERT:Paragraph Body
      paraBody: "<p><ul style='padding-left: 20px;'><li>Présentation des nouveaux produits Canon</li><li>Six sessions de questions/réponses en direct avec des professionnels de l'imagerie</li><li>Projections de courts-métrages</li><li>Présentation détaillée de toutes nos gammes de caméras professionnelles, d'écrans et d'objectifs</li><li>Idéal pour les professionnels des chaînes de télévision, les cinéastes, les réalisateurs indépendants, les vidéastes et tous les professionnels du secteur</li><li>If you’re experiencing any problems with the 3D experience, <a href='https://www.canon-europe.com/pro/events/canon-vision/web-version/?cache=no'>click here</a> to view the products on the Canon website</li></p>",
    },
    footer:{
      // INSERT:Privacy Policy
      privacyPolicyFooter: '<a target="_blank" rel="noopener noreferrer" href="https://myid.canon/canonid/#/policy?ui_language=fr-FR" style="color: #000 !important;">Politique de confidentialité</a>',
    },

    // INSERT:Register //

    // INSERT:Login

    registerLogin: 'Déjà enregistré? <a href="/" style="color: #fff !important;">se connecter</a>',

    // INSERT:Opening Paragraph
    openingPara: 'Remplissez le formulaire ci-dessous et rejoignez-nous pour assister à une démonstration de nos solutions, technologies et produits les plus récents, dispensée par nos experts produit et des professionnels des secteurs de la diffusion, du cinéma, des documentaires et de la production.',

    // INSERT:Form Labels
    firstName: 'Prénom',
    lastName: 'Nom',
    emailAddress: 'Adresse e-mail',
    companyName: 'Nom de la société',
    country: 'Pays',
    contactNumber: 'Numéro à contacter',
    jobTitle: 'Fonction',
    companyType: 'Type de société',
    mainProductionGenre: 'Genre de production principal',
    statementSelect: "Sélectionnez l'énoncé qui s'applique à vous",

    // INSERT:County Dropdowns
    countyDDSelect: 'Saisissez un pays',

    // INSERT:Company Type Dropdowns
    companyTypeDDSelect: "Saisissez un type d'entreprise",
    companyTypeDD1: 'Chaîne TV (Publique)',
    companyTypeDD2: 'Chaîne TV locale (Publique)',
    companyTypeDD3: 'Chaîne TV (Privée)',
    companyTypeDD4: 'Chaîne TV locale (Privée)',
    companyTypeDD5: 'Entreprises de camions régie',
    companyTypeDD6: 'Sociétés de production',
    companyTypeDD7: 'Sociétés de post-production',
    companyTypeDD8: "Entreprises de location d'équipements",
    companyTypeDD9: 'Utilisateur indépendant / Freelance',
    companyTypeDD10: 'Institutionnel',
    companyTypeDD11: 'Lieux de cultes / Églises',
    companyTypeDD12: 'Revendeur / Distributeur',
    companyTypeDD13: 'Intégrateur système',
    companyTypeDD14: 'Gouvernement / Fonction publique',
    companyTypeDD15: 'Armée / Police',
    companyTypeDD16: 'Secteur universitaire',
    companyTypeDD17: 'Enseignement secondaire',
    companyTypeDD18: 'Enseignement primaire',
    companyTypeDD19: 'Autres institutions éducatives',
    companyTypeDD20: 'Étudiants',
    companyTypeDD21: 'Autres',

    // INSERT:Main Production Genre Dropdowns
    GenreDDSelect: 'Saisissez un genre de production principal',
    GenreDD1: 'Film & TV : Documentaire',
    GenreDD2: 'Film & TV : Studio/Production',
    GenreDD3: 'Film & TV : Narration',
    GenreDD4: 'Film & TV : Épisodes',
    GenreDD5: 'Film & TV : Sports',
    GenreDD6: 'Film & TV : Actualités/Journalisme',
    GenreDD7: 'Contenu commercial/publicitaire',
    GenreDD8: 'Contenu institutionnel',
    GenreDD9: 'Contenu éducatif',
    GenreDD10: 'Mariage',
    GenreDD11: 'Musique',
    GenreDD12: 'Jeux vidéos / e-sports',
    GenreDD13: 'Lieux de culte',
    GenreDD14: 'Contenu Internet',
    GenreDD15: 'Contrôle',
    GenreDD16: 'Surveillance',
    GenreDD17: 'Autres',

    // INSERT:Select the statement which applies to you
    select1: 'La photographie ou la vidéo sont des loisirs auxquels je consacre beaucoup de temps',
    select2: 'Je fais des études pour obtenir une qualification en photographie ou en vidéo (diplôme ou brevet)',
    select3: "Je suis parfois rémunéré(e) pour des photos ou vidéos que je prends, mais ce n'est pas mon salaire principal",
    select4: 'Je suis un(e) professionnel(le) de la photo/vidéo à temps plein : je fais des photos/vidéos professionnelles régulièrement',
    select5: "Je travaille dans l'industrie du cinéma/de la radiodiffusion en tant que réalisateur professionnel, cadreur ou autre poste similaire",
    select6: 'Aucune des réponses ci-dessus',

    // INSERT:Email Marketting
    emailMarketting: 'Si vous souhaitez vous inscrire pour recevoir les actualités et offres Canon par e-mail, cochez cette case.',
    emailUnsubscribe: "Vous pourrez vous désabonner à tout moment",

    // INSERT:Mandatory Field
    mandatoryField: 'champ obligatoire',

    // INSERT:Privacy Policy
    privacyPolicy: 'En cliquant sur « SOUMETTRE », vous confirmez avoir lu et accepté la <a target="_blank" rel="noopener noreferrer" href="https://myid.canon/canonid/#/policy">Politique de confidentialité de Canon.</a>',

    // INSERT:Submit
    submitButton: 'SOUMETTRE',

    // INSERT:Footer
    footerLeft: 'Canon Vision. Virtual Pro AV Event<br>&#169; Copyright 2020 All Rights Reserved.',
    footerRight: 'REYDAR is a registered trademark of Engine Creative Agency Ltd. Reydar is licensed from Engine Creative. Experiences are developed by Engine Creative.<br>Engine Creative Agency Ltd, The Church Rooms, Agnes Rd, Northampton, NN2 6EU. Tel: 01604 453177. All rights reserved. Company number 3608666.',

    // INSERT:Thank You
    thankyouTitle: 'Merci de votre inscription.',
    thankyouText: 'Merci de votre inscription à Canon Vision 2020.<br>Vous recevrez bientôt un e-mail de confirmation, nous serons ravis de vous rencontrer.'
  },
  'it': {
    // INSERT:LandingPage //
    landing:{
      // INSERT:Title
      title: 'Canon Vision',

      // Landing Page register
      register: "Non registrato, <a href='/register' style='color: #fff !important;'>registrati</a>",

      // INSERT:Opening Paragraph
      openingPara: 'Scopri la gamma completa di prodotti e soluzioni Canon per i professionisti ed esplora la tecnologia in compagnia dei nostri product specialist e di affermati professionisti del settore, partecipando al nostro evento virtuale.',

      // INSERT:CTA Button
      ctaButton: 'ctaButton',

      // INSERT:Paragraph Heading
      paraHeading: 'Canon Vision: partecipa al nostro evento virtuale dedicato ai prodotti per professionisti',

      // INSERT:Paragraph Body
      paraBody: "<p><ul style='padding-left: 20px;'><li>Presentazione dei prodotti Canon più recenti</li><li>Sei sessioni di Q&A dal vivo con i professionisti</li><li>Proiezioni di cortometraggi</li><li>Approfondimenti dettagliati sulle nostre videocamere professionali, i nostri monitor e la gamma di obiettivi</li><li>L'ambiente ideale per chi lavora nel mondo della televisione, per i direttori della fotografia, i film maker indipendenti e i videomakerC33</li><li>If you’re experiencing any problems with the 3D experience, <a href='https://www.canon-europe.com/pro/events/canon-vision/web-version/?cache=no'>click here</a> to view the products on the Canon website</li></p>",
    },
    footer:{
      // INSERT:Privacy Policy
      privacyPolicyFooter: '<a target="_blank" rel="noopener noreferrer" href="https://myid.canon/canonid/#/policy?ui_language=it-IT" style="color: #000 !important;">politica sulla riservatezza</a>',
    },

    // INSERT:Register //

    // INSERT:Login

    registerLogin: 'Già registrato? <a href="/" style="color: #fff !important;">Registrati</a>',

    // INSERT:Opening Paragraph
    openingPara: 'Compila il modulo sottostante e unisciti a noi per scoprire i prodotti, le tecnologie e le soluzioni più recenti grazie ai nostri esperti di prodotto e a professionisti del settore broadcast, cinematografico, documentario e della produzione.',

    // INSERT:Form Labels
    firstName: 'Nome',
    lastName: 'Cognome',
    emailAddress: 'Indirizzo e-mail',
    companyName: 'Nome azienda',
    country: 'Paese',
    contactNumber: 'Numero di telefono',
    jobTitle: 'Titolo lavoro',
    companyType: 'Tipo di azienda',
    mainProductionGenre: 'Tipo di produzione principale',
    statementSelect: 'Seleziona le affermazioni che ti rappresentano',

    // INSERT:County Dropdowns
    countyDDSelect: 'Immetti un paese',

    // INSERT:Company Type Dropdowns
    companyTypeDDSelect: 'Immetti un tipo di azienda',
    companyTypeDD1: 'TV nazionale (pubblica)',
    companyTypeDD2: 'TV locale (pubblica)',
    companyTypeDD3: 'TV nazionale (privata)',
    companyTypeDD4: 'TV locale (privata)',
    companyTypeDD5: 'Aziende di outside broadcast',
    companyTypeDD6: 'Aziende di produzione',
    companyTypeDD7: 'Aziende di post-produzione',
    companyTypeDD8: 'Aziende di noleggio attrezzature',
    companyTypeDD9: 'Utenti indipendenti/freelance',
    companyTypeDD10: 'Video aziendali',
    companyTypeDD11: 'Luoghi di culto/chiese',
    companyTypeDD12: 'Rivenditore/distributore',
    companyTypeDD13: 'Integratore di sistemi',
    companyTypeDD14: 'Governo/settore pubblico',
    companyTypeDD15: 'Forze di sicurezza/polizia',
    companyTypeDD16: 'Università',
    companyTypeDD17: 'Scuola secondaria',
    companyTypeDD18: 'Scuola primaria',
    companyTypeDD19: 'Altre istituzioni educative',
    companyTypeDD20: 'Studenti',
    companyTypeDD21: 'Altro',

    // INSERT:Main Production Genre Dropdowns
    GenreDDSelect: 'Immetti un tipo di produzione principale',
    GenreDD1: 'Film e TV: documentari',
    GenreDD2: 'Film e TV: studi/produzione',
    GenreDD3: 'Film e TV: fiction',
    GenreDD4: 'Film e TV: serie',
    GenreDD5: 'Film e TV: sport',
    GenreDD6: 'Film e TV: giornalismo',
    GenreDD7: 'Pubblicità',
    GenreDD8: 'Contenuti aziendali',
    GenreDD9: 'Contenuti educativi',
    GenreDD10: 'Matrimonio',
    GenreDD11: 'Musica',
    GenreDD12: 'Videogiochi/eSport',
    GenreDD13: 'Luoghi di culto',
    GenreDD14: 'Contenuti Internet',
    GenreDD15: 'Sorveglianza',
    GenreDD16: 'Monitoraggio',
    GenreDD17: 'Altro',

    // INSERT:Select the statement which applies to you
    select1: 'La fotografia o la videografia è un hobby a cui dedico molto tempo',
    select2: 'Sto studiando per ottenere una qualifica relativa alla fotografia o alla videografia, come una laurea o un diploma',
    select3: 'A volte ricevo un compenso (monetario o non) per le mie foto o i miei video, ma non è la mia principale fonte di reddito',
    select4: 'Sono un professionista della fotografia o della videografia a tempo pieno: mi guadagno da vivere realizzando foto o video in modo professionale',
    select5: 'Lavoro nel settore del cinema o del broadcasting come film-maker, operatore o in un ruolo professionale simile',
    select6: 'Nessuna delle risposte precedenti',

    // INSERT:Email Marketting
    emailMarketting: 'Spunta la casella se desideri ricevere regolarmente via e-mail comunicazioni su prodotti, eventi e servizi Canon.',
    emailUnsubscribe: "Potrai annullare l'iscrizione in qualsiasi momento",

    // INSERT:Mandatory Field
    mandatoryField: 'campo obbligatorio',

    // INSERT:Privacy Policy
    privacyPolicy: "Facendo clic su INVIA, confermi di aver letto e accettato <a target='_blank' rel='noopener noreferrer' href='https://myid.canon/canonid/#/policy'>l'Informativa sulla privacy di Canon.</a>",

    // INSERT:Submit
    submitButton: 'INVIA',

    // INSERT:Footer
    footerLeft: 'Canon Vision. Virtual Pro AV Event<br>&#169; Copyright 2020 All Rights Reserved.',
    footerRight: 'REYDAR is a registered trademark of Engine Creative Agency Ltd. Reydar is licensed from Engine Creative. Experiences are developed by Engine Creative.<br>Engine Creative Agency Ltd, The Church Rooms, Agnes Rd, Northampton, NN2 6EU. Tel: 01604 453177. All rights reserved. Company number 3608666.',

    // INSERT:Thank You
    thankyouTitle: 'Grazie per la registrazione.',
    thankyouText: "Grazie per esserti registrato a Canon Vision 2020.<br>Riceverai un'e-mail di conferma, ti aspettiamo!"
  },
  'es': {
    // INSERT:LandingPage //
    landing:{
      // INSERT:Title
      title: 'Canon Vision',

      // Landing Page register
      register: '¿No registrado? <a href="/register" style="color: #fff !important;">Regístrate</a>',

      // INSERT:Opening Paragraph
      openingPara: 'Explora la gama completa de productos y soluciones Pro AV de Canon y obtén información sobre la tecnología de la mano de nuestro equipo de especiales y de profesionales líderes del sector en nuestro entorno de feria virtual.',

      // INSERT:CTA Button
      ctaButton: 'ctaButton',

      // INSERT:Paragraph Heading
      paraHeading: 'Canon Vision: experimenta nuestro evento virtual sobre Pro AV',

      // INSERT:Paragraph Body
      paraBody: '<p><ul style="padding-left: 20px;"><li>Presentación de los productos Canon más recientes</li><li>Seis sesiones de preguntas y respuestas con profesionales de imagen</li><li>Proyecciones de cortometrajes</li><li>Un análisis en detalle de todos los rangos de objetivos, pantallas y cámaras de vídeo profesionales</li><li>Perfecto para locutores, cinematógrafos, cineastas independientes, videógrafos y mucho másC23</li><li>If you’re experiencing any problems with the 3D experience, <a href="https://www.canon-europe.com/pro/events/canon-vision/web-version/?cache=no">click here</a> to view the products on the Canon website</li></p>',
    },
    footer:{
      // INSERT:Privacy Policy
      privacyPolicyFooter: '<a target="_blank" rel="noopener noreferrer" href="https://myid.canon/canonid/#/policy?ui_language=es-ES" style="color: #000 !important;">Política de privacidad</a>',
    },

    // INSERT:Register //

    // INSERT:Login

    registerLogin: '¿Ya registrado? <a href="/" style="color: #fff !important;">Registrarse</a>',

    // INSERT:Opening Paragraph
    openingPara: 'Completa el siguiente formulario, únete a nosotros y podrás ver una muestra de nuestros últimos productos, tecnologías y soluciones de la mano de expertos y profesionales de los sectores de la emisión, el cine, los documentales y la producción.',

    // INSERT:Form Labels
    firstName: 'Nombre',
    lastName: 'Apellidos',
    emailAddress: 'Correo electrónico',
    companyName: 'Nombre de la empresa',
    country: 'País',
    contactNumber: 'Número de contacto',
    jobTitle: 'Cargo',
    companyType: 'Tipo de empresa',
    mainProductionGenre: 'Tipo de producción principal',
    statementSelect: 'Selecciona la afirmación que se aplique a ti',

    // INSERT:County Dropdowns
    countyDDSelect: 'Por favor seleccione un país',

    // INSERT:Company Type Dropdowns
    companyTypeDDSelect: 'Selecciona un tipo de empresa válido',
    companyTypeDD1: 'Cadena de TV (pública)',
    companyTypeDD2: 'Cadena de TV local (pública)',
    companyTypeDD3: 'Cadena de TV (privada)',
    companyTypeDD4: 'Cadena de TV local (privada)',
    companyTypeDD5: 'Empresas de unidades móviles',
    companyTypeDD6: 'Empresas de producción',
    companyTypeDD7: 'Empresas de posproducción',
    companyTypeDD8: 'Empresas de alquiler de equipo',
    companyTypeDD9: 'Usuario independiente/autónomo',
    companyTypeDD10: 'Empresas',
    companyTypeDD11: 'Lugares de culto/iglesias',
    companyTypeDD12: 'Revendedor/distribuidor',
    companyTypeDD13: 'Integrador de sistemas',
    companyTypeDD14: 'Gobierno/administración pública',
    companyTypeDD15: 'Fuerzas de seguridad/policía',
    companyTypeDD16: 'Universidad/enseñanza superior',
    companyTypeDD17: 'Enseñanza secundaria',
    companyTypeDD18: 'Enseñanza primaria',
    companyTypeDD19: 'Otras instituciones educativas',
    companyTypeDD20: 'Estudiantes',
    companyTypeDD21: 'Otros',

    // INSERT:Main Production Genre Dropdowns
    GenreDDSelect: 'Selecciona un tipo de producción principal válido',
    GenreDD1: 'Cine y TV: documental',
    GenreDD2: 'Cine y TV: estudio/producción',
    GenreDD3: 'Cine y TV: narrativa',
    GenreDD4: 'Cine y TV: episódico',
    GenreDD5: 'Cine y TV: deportes',
    GenreDD6: 'Cine y TV: noticias/periodismo',
    GenreDD7: 'Anuncios/publicidad',
    GenreDD8: 'Contenido corporativo',
    GenreDD9: 'Contenido educativo',
    GenreDD10: 'Boda',
    GenreDD11: 'Música',
    GenreDD12: 'Videojuegos/deportes electrónicos',
    GenreDD13: 'Lugar de culto',
    GenreDD14: 'Contenido de Internet',
    GenreDD15: 'Vigilancia',
    GenreDD16: 'Supervisión',
    GenreDD17: 'Otros',

    // INSERT:Select the statement which applies to you
    select1: 'La fotografía o la videografía es una afición a la que dedico mucho tiempo',
    select2: 'Realizo estudios para obtener una cualificación orientada a la fotografía o la videografía, como un grado o una titulación',
    select3: 'En ocasiones, hago fotos o grabo vídeos para obtener dinero u otras gratificaciones, pero no es mi principal fuente de ingresos',
    select4: 'Me dedico a la fotografía o a la grabación de vídeo profesional a tiempo completo. Me gano la vida haciendo fotos o grabando vídeos profesionalmente y de forma regular',
    select5: 'Trabajo en el sector del cine/la emisión como cineasta profesional, operador de cámara o similar',
    select6: 'Ninguna de las anteriores',

    // INSERT:Email Marketting
    emailMarketting: 'Si quieres recibir las noticias y ofertas de Canon por correo electrónico y todavía no te has suscrito, marca esta casilla.',
    emailUnsubscribe: "Podrás cancelar la suscripción en cualquier momento",

    // INSERT:Mandatory Field
    mandatoryField: 'Campo obligatorio',

    // INSERT:Privacy Policy
    privacyPolicy: 'Al hacer clic en «ENVIAR», confirmas que has leído y entendido la <a target="_blank" rel="noopener noreferrer"href="https://myid.canon/canonid/#/policy">Política de privacidad de Canon</a>.',

    // INSERT:Submit
    submitButton: 'ENVIAR',

    // INSERT:Footer
    footerLeft: 'Canon Vision. Virtual Pro AV Event<br>&#169; Copyright 2020 All Rights Reserved.',
    footerRight: 'REYDAR is a registered trademark of Engine Creative Agency Ltd. Reydar is licensed from Engine Creative. Experiences are developed by Engine Creative.<br>Engine Creative Agency Ltd, The Church Rooms, Agnes Rd, Northampton, NN2 6EU. Tel: 01604 453177. All rights reserved. Company number 3608666.',

    // INSERT:Thank You
    thankyouTitle: 'Gracias por registrarte.',
    thankyouText: 'Gracias por registrarte para Canon Vision 2020.<br>Recibirás un correo electrónico de confirmación, esperamos verte.'
  },
  'de': {
    // INSERT:LandingPage //
    landing:{
      // INSERT:Title
      title: 'Canon Vision',

      // Landing Page register
      register: 'Nicht registriert? <a href="/register" style="color: #fff !important;">Anmelden</a>',

      // INSERT:Opening Paragraph
      openingPara: 'Entdecke die vollständige Serie der Canon Pro AV-Produkte und Lösungen und erhalte von unserem Team aus Produktspezialisten und branchenführenden Experten Einblicke in die Technologie – alles in unserer virtuellen Messehalle.',

      // INSERT:CTA Button
      ctaButton: 'ctaButton',

      // INSERT:Paragraph Heading
      paraHeading: 'Canon Vision: Erlebe unser virtuelles Pro AV Event',

      // INSERT:Paragraph Body
      paraBody: '<p><ul style="padding-left: 20px;"><li>Einführung in unsere neuesten Canon Produkte</li><li>Sechs Live-Fragerunden mit Imaging-Profis</li><li>Kurzfilm-Screenings</li><li>Eingehende Einblicke in unsere professionelle Videokamera sowie Display und Objektiv-Serien.</li><li>Perfekt für Sendeanstalten, Kameraleute, unabhängige Filmemacher, Videografen und viele mehr</li><li>If you’re experiencing any problems with the 3D experience, <a href="https://www.canon-europe.com/pro/events/canon-vision/web-version/?cache=no">click here</a> to view the products on the Canon website</li></p>',
    },
    footer:{
      // INSERT:Privacy Policy
      privacyPolicyFooter: '<a target="_blank" rel="noopener noreferrer" href="https://myid.canon/canonid/#/policy?ui_language=de-DE" style="color: #000 !important;">Datenschutz-Bestimmungen</a>',
    },

    // INSERT:Register //

    // INSERT:Login

    registerLogin: 'Bereits registriert? <a href="/" style="color: #fff !important;">Einloggen</a>',

    // INSERT:Opening Paragraph
    openingPara: 'Füllen Sie das nachstehende Formular aus und begleiten Sie uns auf der Einführung unserer neuesten Produkte, Technologie und Lösungen durch unsere Produktexperten und Profis aus dem Rundfunk-, Film-, Dokumentar- und Produktionsberech.',

    // INSERT:Form Labels
    firstName: 'Vorname',
    lastName: 'Nachname',
    emailAddress: 'E-Mail-Adresse',
    companyName: 'Firmenname',
    country: 'Land',
    contactNumber: 'Kontaktnummer',
    jobTitle: 'Berufsbezeichnung',
    companyType: 'Unternehmensform',
    mainProductionGenre: 'Geschäftsbereich',
    statementSelect: 'Wählen Sie jene Aussage aus, die am besten auf Sie zutrifft',

    // INSERT:County Dropdowns
    countyDDSelect: 'Bitte gültige land eingeben',

    // INSERT:Company Type Dropdowns
    companyTypeDDSelect: 'Bitte gültige Unternehmensform eingeben',
    companyTypeDD1: 'Netzwerk-TV (öffentlich)',
    companyTypeDD2: 'Lokal-TV (öffentlich)',
    companyTypeDD3: 'Netzwerk-TV (privat)',
    companyTypeDD4: 'Lokal-TV (privat)',
    companyTypeDD5: 'Übertragungswagen-Anbieter',
    companyTypeDD6: 'Produktionsunternehmen',
    companyTypeDD7: 'Unternehmen in der Nachbereitung',
    companyTypeDD8: 'Mietfirmen für Ausrüstung',
    companyTypeDD9: 'Unabhängiger Nutzer/Freiberufler',
    companyTypeDD10: 'Corporate',
    companyTypeDD11: 'Gotteshäuser/Kirchen',
    companyTypeDD12: 'Wiederverkäufer/Lieferant',
    companyTypeDD13: 'Systemintegrator',
    companyTypeDD14: 'Regierung/öffentlicher Sektor',
    companyTypeDD15: 'Sicherheitskräfte/Polizei',
    companyTypeDD16: 'Universität/Hochschule',
    companyTypeDD17: 'Weiterführende Schule',
    companyTypeDD18: 'Grundschule',
    companyTypeDD19: 'Andere Bildungseinrichtungen',
    companyTypeDD20: 'Studenten',
    companyTypeDD21: 'Sonstige',

    // INSERT:Main Production Genre Dropdowns
    GenreDDSelect: 'Bitte gültigen Geschäftsbereich auswählen',
    GenreDD1: 'Film & TV: Dokumentationen',
    GenreDD2: 'Film & TV: Studio/Produktion',
    GenreDD3: 'Film & TV: Spielfilme',
    GenreDD4: 'Film & TV: Serien',
    GenreDD5: 'Film & TV: Sport',
    GenreDD6: 'Film & TV: Nachrichten/Journalismus',
    GenreDD7: 'Werbefilme/Reklame',
    GenreDD8: 'Corporate Content',
    GenreDD9: 'Bildung',
    GenreDD10: 'Hochzeit',
    GenreDD11: 'Musik',
    GenreDD12: 'Gaming/e-Sport',
    GenreDD13: 'Gotteshaus',
    GenreDD14: 'Internet-Inhalte',
    GenreDD15: 'Kontrolle',
    GenreDD16: 'Überwachung',
    GenreDD17: 'Sonstiges',

    // INSERT:Select the statement which applies to you
    select1: 'Fotografie oder Videografie ist ein Hobby, mit dem ich viel Zeit verbringe',
    select2: 'Ich absolviere ein Studium mit dem Schwerpunkt Fotografie oder Videografie wie z. B. Diplom-Studiengang',
    select3: 'Manchmal verdiene ich mir mit Fotografie oder Videografie etwas Geld dazu, aber es ist nicht meine Haupteinnahmequelle',
    select4: 'Ich bin hauptberuflich ein Foto- bzw. Videoprofi – ich verdiene meinen Lebensunterhalt mit Fotografie oder Videografie',
    select5: 'Ich arbeite in der Film-/Rundfunkbranche als professionelle Filmemacher, Kameramann o.ä',
    select6: 'Keine der Aussagen trifft zu',

    // INSERT:Email Marketting
    emailMarketting: 'Wenn du dich noch nicht angemeldet hast, um Neuigkeiten und Angebote von Canon per E-Mail zu erhalten, klicke bitte hier.',
    emailUnsubscribe: "Sie können sich jederzeit wieder abmelden",

    // INSERT:Mandatory Field
    mandatoryField: 'Pflichtfeld',

    // INSERT:Privacy Policy
    privacyPolicy: 'Durch Betätigung des „SENDEN“-Buttons bestätigen Sie, dass Sie die <a target="_blank" rel="noopener noreferrer"href="https://myid.canon/canonid/#/policy">Canon Datenschutzerklärung gelesen und akzeptiert haben</a>.',

    // INSERT:Submit
    submitButton: 'SENDEN',

    // INSERT:Footer
    footerLeft: 'Canon Vision. Virtual Pro AV Event<br>&#169; Copyright 2020 All Rights Reserved.',
    footerRight: 'REYDAR is a registered trademark of Engine Creative Agency Ltd. Reydar is licensed from Engine Creative. Experiences are developed by Engine Creative.<br>Engine Creative Agency Ltd, The Church Rooms, Agnes Rd, Northampton, NN2 6EU. Tel: 01604 453177. All rights reserved. Company number 3608666.',

    // INSERT:Thank You
    thankyouTitle: 'Danke für die Registrierung.',
    thankyouText: 'Vielen Dank für Ihre Registrierung bei Canon Vision 2020.<br>Sie erhalten eine Bestätigung per E-Mail, wir freuen uns auf Ihren Besuch.'
  },
  'ru': {
    // INSERT:LandingPage //
    landing:{
      // INSERT:Title
      title: 'Canon Vision',

      // Landing Page register
      register: 'Не зарегистрирован? <a href="/register" style="color: #fff !important;">зарегистрироваться</a>',

      // INSERT:Opening Paragraph
      openingPara: 'Ознакомьтесь с полным ассортиментом профессиональных аудио- и видеопродуктов и решений Canon и узнайте о технологиях от нашей команды специалистов по продукции и ведущих профессионалов в индустрии, посетив виртуальную выставку.',

      // INSERT:CTA Button
      ctaButton: 'ctaButton',

      // INSERT:Paragraph Heading
      paraHeading: 'Canon Vision: посетите наше виртуальное мероприятие для профессионалов аудиовизуальной индустрии',

      // INSERT:Paragraph Body
      paraBody: '<p><ul style="padding-left: 20px;"><li>Презентация новейших продуктов Canon</li><li>Шесть сессий с ответами профессионалов в области работы с изображениями на ваши вопросы</li><li>Короткие кинопоказы</li><li>Подробный обзор нашей линейки профессиональных видеокамер, дисплеев и объективов</li><li>Предназначено для специалистов в сфере вещания, кинематографистов, независимых режиссеров, видеооператоров и т. д.</li><li>If you’re experiencing any problems with the 3D experience, <a href="https://www.canon-europe.com/pro/events/canon-vision/web-version/?cache=no">click here</a> to view the products on the Canon website</li></p>',
    },
    footer:{
      // INSERT:Privacy Policy
      privacyPolicyFooter: '<a target="_blank" rel="noopener noreferrer" href="https://myid.canon/canonid/#/policy?ui_language=ru-RU" style="color: #000 !important;">политика конфиденциальности</a>',
    },

    // INSERT:Register //

    // INSERT:Login

    registerLogin: 'Уже зарегистрирован? <a href="/" style="color: #fff !important;">войти в систему</a>',

    // INSERT:Opening Paragraph
    openingPara: 'Заполни приведенную ниже форму и присоединяйся к мероприятию, на котором наши эксперты и профессионалы в сфере телевещания, кино, документалистики и производства представят наши новейшие продукты, технологии и решения.',

    // INSERT:Form Labels
    firstName: 'Имя',
    lastName: 'Фамилия',
    emailAddress: 'Адрес электронной почты',
    companyName: 'Название компании',
    country: 'Страна',
    contactNumber: 'Контактный телефон',
    jobTitle: 'Профессия',
    companyType: 'Тип компании',
    mainProductionGenre: 'Основной жанр производства',
    statementSelect: 'Выбери утверждение, которое применимо к тебе',

    // INSERT:County Dropdowns
    countyDDSelect: 'Выберите вашу страну',

    // INSERT:Company Type Dropdowns
    companyTypeDDSelect: 'Выбери тип компании',
    companyTypeDD1: 'Сетевое телевидение (общедоступное)',
    companyTypeDD2: 'Местное телевидение (общедоступное)',
    companyTypeDD3: 'Сетевое телевидение (частное)',
    companyTypeDD4: 'Местное телевидение (частное)',
    companyTypeDD5: 'Передвижные телевизионные станции',
    companyTypeDD6: 'Производственные компании',
    companyTypeDD7: 'Компании, занимающиеся постпродакшном',
    companyTypeDD8: 'Компания по аренде оборудования',
    companyTypeDD9: 'Независимый пользователь/фрилансер',
    companyTypeDD10: 'Корпоративные видео',
    companyTypeDD11: 'Религиозные организации/церкви',
    companyTypeDD12: 'Ресселлер/дистрибьютор',
    companyTypeDD13: 'Интегратор систем и решений',
    companyTypeDD14: 'Правительство/государственный сектор',
    companyTypeDD15: 'Службы безопасности/полиция',
    companyTypeDD16: 'Университет/колледж',
    companyTypeDD17: 'Средняя школа',
    companyTypeDD18: 'Начальная школа',
    companyTypeDD19: 'Другие образовательные учреждения',
    companyTypeDD20: 'Студенты',
    companyTypeDD21: 'Другое',

    // INSERT:Main Production Genre Dropdowns
    GenreDDSelect: 'Выбери основной жанр производства',
    GenreDD1: 'Кино и ТВ: документальные фильмы',
    GenreDD2: 'Кино и ТВ: студия/производство',
    GenreDD3: 'Кино и ТВ: нарратив',
    GenreDD4: 'Кино и ТВ: сериал',
    GenreDD5: 'Кино и ТВ: спорт',
    GenreDD6: 'Кино и ТВ: новости/журналистика',
    GenreDD7: 'Реклама',
    GenreDD8: 'Корпоративный контент',
    GenreDD9: 'Образовательные материалы',
    GenreDD10: 'Свадьба',
    GenreDD11: 'Музыка',
    GenreDD12: 'Игры/киберспорт',
    GenreDD13: 'Религиозная организация',
    GenreDD14: 'Интернет-контент',
    GenreDD15: 'Видеонаблюдение',
    GenreDD16: 'Контроль за',
    GenreDD17: 'Прочее',

    // INSERT:Select the statement which applies to you
    select1: 'Фотография или видеография — это хобби, которому я посвящаю много времени',
    select2: 'Я учусь на специальности, связанной с фотографией или видеографией (получаю диплом или степень)',
    select3: 'Иногда я делаю фотографии или видео за деньги или вознаграждение, но это не является моим основным источником дохода',
    select4: 'Я профессионально занимаюсь фотографией или видеографией; это является моей основной работой и источником дохода',
    select5: 'Я работаю в индустрии телевидения/кинематографа и являюсь профессиональным оператором, кинематографистом или занимаю схожую должность',
    select6: 'Ничего из вышеперечисленного',

    // INSERT:Email Marketting
    emailMarketting: 'Установи флажок, если хочешь получать новости о продуктах, мероприятиях и сервисах Canon по электронной почте.',
    emailUnsubscribe: "Ты можешь отписаться от рассылки в любое время",

    // INSERT:Mandatory Field
    mandatoryField: 'обязательное поле',

    // INSERT:Privacy Policy
    privacyPolicy: 'Нажимая ОТПРАВИТЬ, ты подтверждаешь, что ознакомился(-ась) и понял(-а) условия <a target="_blank" rel="noopener noreferrer"href="https://myid.canon/canonid/#/policy">Политики конфиденциальности Canon</a>.',

    // INSERT:Submit
    submitButton: 'ОТПРАВИТЬ',

    // INSERT:Footer
    footerLeft: 'Canon Vision. Virtual Pro AV Event<br>&#169; Copyright 2020 All Rights Reserved.',
    footerRight: 'REYDAR is a registered trademark of Engine Creative Agency Ltd. Reydar is licensed from Engine Creative. Experiences are developed by Engine Creative.<br>Engine Creative Agency Ltd, The Church Rooms, Agnes Rd, Northampton, NN2 6EU. Tel: 01604 453177. All rights reserved. Company number 3608666.',

    // INSERT:Thank You
    thankyouTitle: 'Спасибо за регистрацию.',
    thankyouText: 'Благодарим за регистрацию на событие Canon Vision 2020.<br>Ты получишь электронное сообщение с подтверждением, c нетерпением ждем встречи на этом мероприятии.'
  },
}

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'es', // set fallback locale
  messages, // set locale messages
});

export default i18n;
